const STANDARD_UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
const COMPACT_UUID_REGEX = /^[0-9a-f]{32}$/i

export function isFullOrderUuidSearchText(searchText: string): boolean {
  return STANDARD_UUID_REGEX.test(searchText) || COMPACT_UUID_REGEX.test(searchText)
}

export function isOrderNumberSearchText(searchText: string): boolean {
  return /^\d+$/.test(searchText)
}

export function isValidSearchOrdersQueryText(searchText: string): boolean {
  return isFullOrderUuidSearchText(searchText) || isOrderNumberSearchText(searchText)
}
